import { http } from "../http-common";

const saveAllBySubject = (subjectId: number | string, answers: { questionId: number; option: string }[]) => {
    return http.post(`/question-answers/subject/${subjectId}/bulk`, { answers });
};

const getSubjectAnswers = (subjectId: number | string) => {
    return http.get(`/question-answers/me/subject/${subjectId}`);
};

const resetSubjectAnswers = (subjectId: number | string) => {
    return http.delete(`/question-answers/subject/${subjectId}`);
};

const QuestionAnswerService = {
    saveAllBySubject,
    getSubjectAnswers,
    resetSubjectAnswers,
};

export default QuestionAnswerService;
